import React from "react";
import PropTypes from "prop-types";
import { withStyles, Button } from "@material-ui/core";
//import styles from "../styles/StylesMain";

//import "../styles/App.scss";

const styles = {};

class GenericErrorComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: "Se ha producido un error, contacte con el administrador",
    };
    if (this.props.errorMsg) {
      this.setState({ errorMsg: this.props.errorMsg });
    }
  }

  render() {
    return (
      <div className="generic-error-component">
        <div className="contMsjError">
          <div className="titMsjError">
            <p className="error">Ha ocurrido un problema</p>
          </div>
          <div className="MsjError">
            <div className="printError">{this.state.errorMsg}</div>
            <div className="btnVolver">
              <Button
                label="VOLVER"
                variant="contained"
                className="botonMoradoOscuro"
                color="primary"
                fullWidth={true}
              >
                aceptar
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GenericErrorComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

const GenericError = withStyles(styles)(GenericErrorComponent);
export default GenericError;
